// Ein Feld mit data-required-unless="<Name>" ist Pflicht, solange im selben
// Formular keine Checkbox dieses Namens gewählt ist - etwa die E-Mail eines
// neuen Tenant-Admins, wenn kein vorhandener ausgewählt ist. Mit
// data-optional-when="<Name>=<Wert>" ist es auch keine Pflicht, solange die
// Auswahl dieses Namens auf dem Wert steht - etwa beim Status Interessent.
// data-required-message ersetzt dann die allgemeine Meldung des Browsers.
// Ohne JavaScript prüft allein der Server.
export default function requiredUnless() {
  document.querySelectorAll('[data-required-unless]').forEach(function (field) {
    if (!field.form) return;
    const name = field.dataset.requiredUnless;
    const boxes = Array.from(field.form.elements).filter((el) => el.type === 'checkbox' && el.name === name);
    if (boxes.length === 0) return;
    const [optionalName, optionalValue] = (field.dataset.optionalWhen || '').split('=');
    const optional = optionalName ? field.form.elements.namedItem(optionalName) : null;

    const update = function () {
      field.required = !boxes.some((box) => box.checked) && !(optional && optional.value === optionalValue);
      field.setCustomValidity('');
    };
    boxes.forEach((box) => box.addEventListener('change', update));
    if (optional && optional.addEventListener) optional.addEventListener('change', update);
    field.addEventListener('input', () => field.setCustomValidity(''));
    field.addEventListener('invalid', function () {
      if (field.validity.valueMissing && field.dataset.requiredMessage) {
        field.setCustomValidity(field.dataset.requiredMessage);
      }
    });
    update();
  });
}
